export default "__VITE_ASSET__d30195af__"